import React from 'react';
import './Card.css';

const Card = ({
  children,
  hover = false,
  padding = 'md',
  className = '',
  ...props
}) => {
  const classes = [
    'p-card',
    hover && 'p-card--hover',
    `p-card--pad-${padding}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;
